import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-public-dashboard',
  templateUrl: './public-dashboard.component.html',
  styleUrl: './public-dashboard.component.scss'
})
export class PublicDashboardComponent {

  constructor(
    private router: Router,
  ) {
  }

  routerAbout() {
    this.router.navigate(['/apropos']);
  }

}
